import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useAppContext } from "../../../AppProvider";
import { faMoneyBillTransfer } from "../../../utilities/fontawesomeIcons";
import { useIndexCodCollectionsContext } from "../providers/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getAllCODSuppliers,
  getAllCompanies,
} from "../../../Components/Selects/AsyncSelect/api";
import {
  getCarrierOptionStyle,
  getCompanyOptionStyle,
} from "../../../Components/Selects/AsyncSelect/styles";

export const isDisabledLiquidateLabels = (selectedRows) => {
  const { accessTokenPayload } = useAppContext();
  return !selectedRows.every(
    (item) => item.collectionDate && item.ownerId === accessTokenPayload.owner
  );
};

export const useListProps = () => {
  const { dictionary, accessTokenPayload } = useAppContext();
  const { setModalConfig } = useIndexCodCollectionsContext();

  return {
    path: "/shipment-service/cod-collections",
    sorting: [
      {
        orderBy: "desc",
        column: "collectionDate",
        icon: faArrowDownShortWide,
        label: dictionary.dates.receipt_date,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "collectionDate",
        icon: faArrowUpShortWide,
        label: dictionary.dates.receipt_date,
        isDefault: false,
      },
    ],
    banner: {
      enabled: false,
    },
    title: dictionary.cod_collections.my_cod_collections,
    omnisearch: {
      enabled: true,
      placeholder: dictionary.references.references,
    },
    filters: {
      name: "cod_collections",
      preserve: false,
      list: [
        {
          fieldName: "collectionDate",
          label: dictionary.dates.receipt_date,
          type: "datepicker",
          primary: true,
          col: 3,
        },
        {
          fieldName: "supplierType",
          label: dictionary.words.typology,
          type: "select",
          options: [
            {
              value: "CARRIER",
              label: dictionary.shipments.collection_ms,
            },
            {
              value: "COMPANY",
              label: dictionary.shipments.liquidation_ms + " ",
            },
          ],
          primary: true,
          col: 3,
          preciseSearch: true,
          hidden:
            accessTokenPayload.owner !== "7f8625b9-973b-4c66-80af-346b49cde2e7",
        },
        {
          fieldName: "supplierId",
          label: dictionary.registries.supplier,
          type: "select",
          loadOption: getAllCODSuppliers,
          primary: true,
          col: 3,
          optionStyle: (option) => {
            const Option = getCarrierOptionStyle(option);
            return <Option />;
          },
          preciseSearch: true,
          optionValue: "id",
          hidden:
            accessTokenPayload.owner !== "7f8625b9-973b-4c66-80af-346b49cde2e7",
        },
        {
          fieldName: "customerId",
          label: dictionary.registries.customer,
          type: "async-select",
          loadOptions: (searchValue, pagination) => {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCompanies(params);
          },
          primary: true,
          col: 3,
          optionStyle: (option) => {
            const Option = getCompanyOptionStyle(option);
            return <Option />;
          },
          preciseSearch: true,
          hidden:
            accessTokenPayload.owner !== "7f8625b9-973b-4c66-80af-346b49cde2e7",
        },
      ],
    },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          setModalConfig({
            isOpen: true,
            title: dictionary.cod_returns.liquidate_labels,
            action: "codLiquidation",
            data: selectedRows.map((r) => r.id),
          }),
        isDisabled: isDisabledLiquidateLabels,
        label: dictionary.cod_returns.liquidate_labels,
        icon: <FontAwesomeIcon icon={faMoneyBillTransfer} />,
        className: "button-1 button-1-transparent",
      },
    ],
  };
};
